export default function MediaService($http, appSettings) {
  'ngInject';
  const baseURL = `${appSettings.InReachMediaEndpoint}`;

  return {
    deleteImage: function (imageId) {
      const endpoint = `${baseURL}/images/${imageId}`;
      return $http.delete(endpoint);
    },

    updateImage: function (image) {
      const endpoint = `${baseURL}/images/${image.id}`;
      return $http.put(endpoint, image);
    }
  };
}